class ShowHide {
    constructor(isShowing){
        this.isShowing = (isShowing !== undefined) ? isShowing : false
    }
    show(){
        this.isShowing = true;
    }
    hide(){
        this.isShowing = false;
    }
    toggle(){
        this.isShowing = !this.isShowing;
    }
}

let tmr;

function Wait(delay, obj){
    return new Promise(resolve => {
        if(tmr){
            clearTimeout(tmr);
            tmr = null;
        }
        tmr = setTimeout( ()=>{
            resolve(obj);
        }, delay)
    })
}

export {
    ShowHide,
    Wait
}